
import './App.css';
import FloatingButtons from './components/FloatingButtons';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import Home from './pages/Home';
import { Routes, Route } from "react-router-dom";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/terms" element={<TermsConditions />} />
      </Routes>
      <FloatingButtons/>
    </div>
  );
}

export default App;
